import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert } from '@cochlear-design-system/foundation';
import AsyncNotificationWidget from '../AsyncNotificationWidget';
import providerService from '../../services/providerService';
import { getLabelsForFields } from '../../utils/labelHelper';
import { routes } from '../../config';

const MainContentBlock = ({ rendering }) => {
  const labels = getLabelsForFields(rendering.fields);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [error, setError] = useState(query.get('error'));
  const [message, setMessage] = useState();

  useEffect(() => {
    if (error === 'provider') {
      setMessage(labels['labels.common.mcpFeaturesError']);
    }
  }, [error]);

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== routes.mcp.domain) return;
      if (typeof e.data === 'object') {
        if ('pageEvent' in e.data) {
          switch (e.data.pageEvent.type) {
            case 'providerError':
              if (e.data.pageEvent.target === 'dashboard') {
                providerService.updateProviderDetails(
                  'hasProviderError',
                  true,
                );
                setError('provider');
              }
              break;
            default:
              break;
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setError('');
    }, 60000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <div className="ccl__container dpx__main-content">
      {error && message && (
        <div className="dpx__alert-container">
          <Alert
            actions={[]}
            dismissible
            heading=""
            onClose={() => {
              setError('');
            }}
            timestamp=""
          >
            {message}
          </Alert>
        </div>
      )}
      <AsyncNotificationWidget rendering={rendering} />
    </div>
  );
};

export default MainContentBlock;
